// Canonical display labels for strategy types.
// API values (PYRAMID_HEDGING, DELTA_HEDGED_SHORT_STRANGLE) never change —
// only the text shown to users is controlled here.

export const STRATEGY_LABELS = {
  PYRAMID_HEDGING:             "Pyramid Hedging",
  DELTA_HEDGED_SHORT_STRANGLE: "DHSS",
  FUTURES_PYRAMID_HEDGING:     "Futures Pyramid Hedging",
  WEEKLY_INDEX_SHORT_STRADDLE: "WISS",
};

/** Returns the human-readable label for a strategy type value. */
export const strategyLabel = (type) => STRATEGY_LABELS[type] || type;

/** Ordered list used for dropdowns. */
export const STRATEGY_OPTIONS = [
  { value: "PYRAMID_HEDGING",             label: "Pyramid Hedging" },
  { value: "DELTA_HEDGED_SHORT_STRANGLE", label: "DHSS" },
  { value: "FUTURES_PYRAMID_HEDGING",     label: "Futures Pyramid Hedging" },
  { value: "WEEKLY_INDEX_SHORT_STRADDLE", label: "WISS" },
];
